import {
  Checkbox,
  Flex,
  Heading,
  IconArrowOpenDownSolid,
  IconArrowOpenEndSolid,
  List,
  Spinner,
  Text,
  ToggleGroup,
  View,
} from "@instructure/ui";
import { t } from "i18next";
import React from "react";

const CourseOptions = ({
  loSync,
  handleLoSyncCheck,
  course,
  syncedMappings,
  learningOutcomeType,
  readOnly,
  isFutureMap,
}) => {
  const loType = learningOutcomeType === "islo" ? "ILO" : "PLO";
  return (
    <Flex wrap="wrap" gap="small">
      <Flex.Item width="100%">
        <Heading as="h2" level="h4" border="bottom">
          {t("curriculumMap.mappingSyncSettings")}
        </Heading>
      </Flex.Item>
      <Flex.Item width="100%">
        <Checkbox
          size="small"
          label={t("curriculumMap.autoSyncLabel", {
            loType: loType,
            course: course.course_summary.code,
          })}
          checked={loSync}
          onChange={(e) => handleLoSyncCheck(e.target.checked)}
          disabled={readOnly}
        />
      </Flex.Item>
      <Flex.Item width="100%">
        <ToggleGroup
          icon={
            syncedMappings ? (
              IconArrowOpenEndSolid
            ) : (
              <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
            )
          }
          iconExpanded={
            syncedMappings ? (
              IconArrowOpenDownSolid
            ) : (
              <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
            )
          }
          summary={
            syncedMappings ? (
              t("curriculumMap.autoSyncToggleLabel", {
                count: syncedMappings.length,
                state: !isFutureMap
                  ? t("curriculumMap.autoSyncToggleCurrent")
                  : t("curriculumMap.autoSyncToggleFuture"),
                course: course.course_summary.code,
              })
            ) : (
              <Text>{t("global.loading")}...</Text>
            )
          }
          toggleLabel={t("curriculumMap.autoSyncToggleScreenReaderLabel", {
            course: course.course_summary.code,
          })}
          size="small"
        >
          <View as="div" maxHeight={250} overflowY="auto">
            <View as="div" padding="small">
              {syncedMappings ? (
                syncedMappings.length > 0 ? (
                  <List itemSpacing="small">
                    {syncedMappings.map((outcome) => (
                      <List.Item key={outcome.id}>{outcome.name}</List.Item>
                    ))}
                  </List>
                ) : (
                  <Text fontStyle="italic">
                    {t("curriculumMap.noAutoSyncedOutcomes")}
                  </Text>
                )
              ) : (
                t("global.loading") + "..."
              )}
            </View>
          </View>
        </ToggleGroup>
      </Flex.Item>
    </Flex>
  );
};

export default CourseOptions;
